import { defineStore } from 'pinia'
import Storages from 'js-storage'

/**
 * Cache store - remplace l'ancien cache.module.js
 * Gère les données de cache non couvertes par les stores métier :
 *  - filter (filtre général)
 *  - searchBar (recherche par page)
 *  - bookmark (favoris)
 *  - filter_layer (état des calques sur la carte)
 *  - filter_version (état visible/masqué des versions sur la carte)
 *  - pro_projection (projection du projet courant)
 */
export const useCacheStore = defineStore('cache', {
  persist: true,
  state: () => ({
    filter: {},
    searchBar: {},
    bookmark: {},
    filter_layer: {},
    filter_version: {},
    pro_projection: ''
  }),
  getters: {
    getFilter () {
      return this.filter
    },
    getFilterUrl () {
      return (prefix) => {
        prefix = prefix || 'tsk'
        const filter = this.filter
        let url = ''
        for (const prop in filter) {
          let valid = true
          valid = (prefix.length > 0 && prop.substring(0, 3) !== prefix && prop.substring(4, 7) !== prefix) ? false : valid
          valid = (filter[prop] == null || filter[prop] === undefined || filter[prop].length <= 0) ? false : valid
          if (valid) {
            if (prop.slice(-4) === '_arr') {
              filter[prop].forEach((item) => {
                url += (item && url.length && item.length) ? '&' : ''
                url += (item && item.length) ? prop.slice(0, -4) + '[]=' + item : ''
              })
            } else {
              url += (url.length) ? '&' : ''
              url += prop + '=' + filter[prop]
            }
          }
        }
        return url
      }
    },
    getFiltrerFromStorage () {
      // Avec la persistance Pinia, le filtre est déjà restauré
      return this.filter || {}
    },
    getSearchBar () {
      return this.searchBar
    },
    getSearchBarItem () {
      return (item) => {
        if (this.searchBar !== undefined) {
          return this.searchBar[item]
        }
        return ''
      }
    },
    getBookmark () {
      return this.bookmark
    }
  },
  actions: {
    setFilter (filter) {
      this.filter = filter
    },
    setSearchBar (searchBar) {
      this.searchBar = searchBar
    },
    setSearchBarItem (item, value) {
      this.searchBar[item] = value
    },
    setBookmark (bookmark) {
      this.bookmark = bookmark
    },
    setFilterLayer (filterLayer) {
      this.filter_layer = filterLayer
    },
    setFilterVersion (filterVersion) {
      this.filter_version = filterVersion
    },
    setProProjection (proProjection) {
      this.pro_projection = proProjection
    },
    /**
     * Initialise le cache depuis le storage legacy (migration ancien format).
     * À appeler une seule fois au démarrage si la clé legacy existe encore.
     */
    initFromLegacyStorage (appCod) {
      if (Storages.localStorage.isSet(appCod + '_cache')) {
        const cache = Storages.localStorage.get(appCod + '_cache')
        if (cache.filter) { this.filter = cache.filter }
        if (cache.searchBar) { this.searchBar = cache.searchBar }
        if (cache.bookmark) { this.bookmark = cache.bookmark }
        if (cache.filter_layer) { this.filter_layer = cache.filter_layer }
        if (cache.filter_version) { this.filter_version = cache.filter_version }
        if (cache.pro_projection !== undefined) { this.pro_projection = cache.pro_projection }
        // Nettoyage de l'ancienne clé legacy une fois migrée
        Storages.localStorage.remove(appCod + '_cache')
      }
    }
  }
})
